/**
 * 支持从外部直接传入时间对象、日期格式
 */
class BaseDate {

  constructor(time = new Date()) {
    if (typeof time === 'string') {
      time = new Date(time)
    }
    // JS 日期对象
    this.dateObj = time
    // 当前时间戳
    this.timeStamp = this.dateObj.getTime()
    // 当前年
    this.year = this.dateObj.getFullYear()
    // 当前月（月份前面也许有 0 ，所以只能以字符串方式存储）
    this.month = this.dateObj.getMonth() + 1 < 10 ? ('0' + (this.dateObj.getMonth() + 1)) : (this.dateObj.getMonth() + 1)
    // 当前日
    this.day = this.dateObj.getDate() < 10 ? `0${this.dateObj.getDate()}` : this.dateObj.getDate()
    // 当前日期
    this.dateStr = `${this.year}/${this.month}/${this.day}`
  }

  // 传入连字符，替换日期字符串中的“/”连字符
  formatDateStr(connector = '-') {
    if (connector === '/') {
      return this.dateStr
    }
    return this.dateStr.replace(/\//g, connector)
  }
}

export default class Calendar extends BaseDate {

  constructor(time = new Date()) {
    super(time)
    // 本月中旬日期，时间戳（用来计算上个月与这个月的年月）
    this._midmonth = new Date(`${this.year}/${this.month}/15`).getTime()
    // 根据星期判断日历前面空出多少位
    this.frontSpace = new Date(`${this.year}/${this.month}/1`).getDay()
    // 该月的每一天
    this.days = this.getDays()
  }

  _structureYearAndMonth(midmonth) {
    midmonth = new Date(midmonth)
    return {
      year: new BaseDate(midmonth).year,
      month: new BaseDate(midmonth).month
    }
  }

  getPrevDate() {
    const _prevMidmonth = this._midmonth - 24 * 60 * 60 * 1000 * 30
    return this._structureYearAndMonth(_prevMidmonth)
  }

  getNextDate() {
    const _nextMidmonth = this._midmonth + 24 * 60 * 60 * 1000 * 30
    return this._structureYearAndMonth(_nextMidmonth)
  }

  // 当前总天数
  getTotalDay() {
    return new Date(this.year, this.month, 0).getDate()
  }
  // 获取年月
  getYM() {
    return {
      year: this.year,
      month: this.month
    }
  }
  // 获取年月日
  getYMD() {
    return {
      year: this.year,
      month: this.month,
      day: this.date
    }
  }
  isFuture({year, month, day}) {
    return new Date(`${year}/${month}/${day}`).getTime() > new Date().getTime()
  }
  // 需要展示在页面上的日历数据
  getDays() {
    const { year, month } = this
    const days = []
    /**
     * 2018/09/01 之前的月份全都不能上报
     * @param i
     * @returns {string}future 不仅代表未来不可上报状态，也代表之前的不可上报状态
     */
    const getState = i => this.timeStamp < new Date('2018/09/01').getTime()
      ? 'future'
      : this.isFuture({ ...this.getYM(), day: i })
        ? 'future'
        : 'canReport'
    for (let i = 1; i <= this.getTotalDay(); i++) {
      let day = i < 10 ? '0' + i : i
      days.push({
        ...this.getYMD(),
        day,
        dateStr: `${year}-${month}-${day}`,
        state: getState(i)
      })
    }
    return days
  }
  // 拼接日历头部的标题
  getMonthHead() {
    return `${this.year}年${(this.month + '').replace(/^0/, '')}月份`
  }
  // 判断往后加一个月是否还属于过去与当下
  canGetNext() {
    const nextDateStr = `${this.getNextDate().year}/${this.getNextDate().month}`
    const currentMonthStr = `${new BaseDate().year}/${new BaseDate().month}`
    return nextDateStr <= currentMonthStr
  }
}



// WEBPACK FOOTER //
// ./src/modules/dataReport/calendar/calendar.js